type UnknownRecord = Record<string, unknown>;

const unwrapKeys = [
  'data',
  'item',
  'items',
  'result',
  'results',
  'record',
  'records',
  'activity',
  'activities',
  'events',
  'responseItem',
  'responseItems',
] as const;

export const asRecord = (value: unknown): UnknownRecord | null =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
    ? (value as UnknownRecord)
    : null;

export const asString = (value: unknown): string =>
  typeof value === 'string' ? value : '';

export const asBoolean = (value: unknown): boolean => value === true;

export const asNullableNumber = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  return null;
};

export const asStringArray = (value: unknown): string[] =>
  Array.isArray(value)
    ? value.filter((item): item is string => typeof item === 'string')
    : [];

export const extractRecord = (value: unknown): UnknownRecord | null => {
  const record = asRecord(value);

  if (!record) {
    return null;
  }

  for (const key of unwrapKeys) {
    const nestedRecord = extractRecord(record[key]);
    if (nestedRecord) {
      return nestedRecord;
    }
  }

  return record;
};

export const extractArray = (value: unknown): unknown[] => {
  if (Array.isArray(value)) {
    return value;
  }

  const record = asRecord(value);
  if (!record) {
    return [];
  }

  for (const key of unwrapKeys) {
    const nestedValue = record[key];
    if (Array.isArray(nestedValue)) {
      return nestedValue;
    }

    const nestedArray = extractArray(nestedValue);
    if (nestedArray.length > 0) {
      return nestedArray;
    }
  }

  return [];
};
